<!-- 🧭 Sidebar Navigation - Navegación lateral -->
<template>
  <v-navigation-drawer
    v-if="shouldShowNavigation"
    :model-value="true"
    :rail="collapsed && !forceExpanded"
    location="left"
  :width="320"
    :rail-width="64"
    class="sidebar-navigation"
    elevation="2"
    permanent
    app
    
  >
    <!-- 🎯 Header/Logo -->
    <div class="sidebar-header pa-4">
  <div v-if="!isRail" class="d-flex align-center justify-space-between">
        <div class="d-flex align-center">
          <div>
            <h6 class="text-h6 font-weight-bold">MGI</h6>
            <p class="text-caption text-medium-emphasis ma-0">Sistema</p>
          </div>
        </div>
        <!-- 🍔 Menu Toggle Button -->
        <v-btn
          icon="mdi:menu"
          variant="text"
          size="small"
          @click="onToggleClick"
          aria-label="Toggle menu"
          class="menu-toggle-btn"
        />
      </div>
  <div v-else class="d-flex flex-column align-center" style="width: 100%">
        <!-- 🍔 Menu Toggle Button (collapsed) -->
        <v-btn
          icon="mdi:menu"
          variant="text"
          size="small"
          @click="onToggleClick"
          aria-label="Toggle menu"
        class="menu-toggle-btn mb-2"
        />
      </div>
    </div>

    <v-divider />

    <!-- 🧭 Navigation Items -->
    <v-list
      class="flex-grow-1 navigation-list"
      :nav="true"
      density="compact"
      v-model:opened="openedGroups"
      style="overflow-y: auto; max-height: calc(100vh - 200px);"
    >
      <!-- 🏠 Dashboard -->
      <v-list-item
        v-if="admitsName('Dashboard')"
        prepend-icon="mdi:view-dashboard"
        title="Dashboard"
        :to="{ name: 'Dashboard' }"
        :active="$route.name === 'Dashboard'"
        class="nav-item"
      >
  <template v-if="!isRail" #append>
          <v-chip
            v-if="dashboardNotifications > 0"
            :text="dashboardNotifications.toString()"
            color="primary"
            size="x-small"
          />
        </template>
      </v-list-item>

      <!-- 👑 Dashboard SuperAdmin -->
      <v-list-item
        v-if="hasSuperAdminDashboard && admitsName('SuperAdminDashboard')"
        prepend-icon="mdi:shield-crown"
        title="Dashboard SuperAdmin"
        :to="{ name: 'SuperAdminDashboard' }"
        :active="$route.name === 'SuperAdminDashboard'"
        class="nav-item superadmin-item"
      >
  <template v-if="!isRail" #append>
          <v-chip
            color="primary"
            size="x-small"
            variant="flat"
          >
            <v-icon icon="mdi:crown" size="x-small" class="mr-1"></v-icon>
            SA
          </v-chip>
        </template>
      </v-list-item>

      <v-divider class="my-2" />

      <!-- 🎯 SUPERVISIÓN OPERATIVA (Field Supervisor) -->
  <v-list-group v-if="hasSupervisorModules && admitsAnyName(['FieldSupervisorDashboard', 'SupervisorIncidents', 'SupervisorMaps', 'FieldSupervisorReport'])" value="supervision">
        <template #activator="{ props }">
          <v-list-item
            v-bind="props"
            prepend-icon="mdi:account-supervisor"
            :title="isRail ? '' : 'Supervisión'"
            color="orange"
            @click="ensureExpandedForInteraction()"
          />
        </template>

        <!-- Dashboard Operativo Field Supervisor -->
        <v-list-item
          v-if="admitsName('FieldSupervisorDashboard')"
          prepend-icon="mdi:view-dashboard"
          title="Dashboard Operativo"
          :to="{ name: 'FieldSupervisorDashboard' }"
          :active="$route.name === 'FieldSupervisorDashboard'"
          class="nav-subitem"
        />

        <v-list-item
          v-if="hasSupervisorIncidents && admitsName('SupervisorIncidents')"
          prepend-icon="mdi:clipboard-alert"
          title="Mis Incidencias"
          :to="{ name: 'SupervisorIncidents' }"
          :active="$route.name === 'SupervisorIncidents'"
          class="nav-subitem"
        >
          <template v-if="!collapsed" #append>
            <v-badge
              v-if="supervisorIncidentsCount > 0"
              :content="supervisorIncidentsCount"
              color="warning"
              size="small"
            />
          </template>
        </v-list-item>

        <v-list-item
          v-if="hasSupervisorMaps && admitsName('SupervisorMaps')"
          prepend-icon="mdi:map-marker-radius"
          title="Mapas de Campo"
          :to="{ name: 'SupervisorMaps' }"
          :active="$route.name === 'SupervisorMaps'"
          class="nav-subitem"
        />

        <v-list-item
          v-if="hasFieldSupervisorReports && admitsName('FieldSupervisorReport')"
          prepend-icon="mdi:clipboard-check"
          title="Reportes de Campo"
          :to="{ name: 'FieldSupervisorReport' }"
          :active="$route.name === 'FieldSupervisorReport'"
          class="nav-subitem"
        />
      </v-list-group>

      <!-- � OPERACIONES DE RUTA (Route Operator) -->
  <v-list-group v-if="hasRouteOperatorModules && admitsAnyName(['RouteOperatorDashboard', 'RoutePOSManagement', 'RouteOperatorMap'])" value="route-ops">
        <template #activator="{ props }">
          <v-list-item
            v-bind="props"
            prepend-icon="mdi:truck-delivery"
            :title="isRail ? '' : 'Operaciones de Ruta'"
            color="indigo"
            @click="ensureExpandedForInteraction()"
          />
        </template>

        <!-- Dashboard RouteOperator -->
        <v-list-item
          v-if="hasRouteOperatorModules && admitsName('RouteOperatorDashboard')"
          prepend-icon="mdi:view-dashboard"
          title="Dashboard"
          :to="{ name: 'RouteOperatorDashboard' }"
          :active="$route.name === 'RouteOperatorDashboard'"
          class="nav-subitem"
        />

        <v-list-item
          v-if="hasRoutePOSManagement && admitsName('RoutePOSManagement')"
          prepend-icon="mdi:store-marker"
          title="Gestión de POS"
          :to="{ name: 'RoutePOSManagement' }"
          :active="$route.name === 'RoutePOSManagement'"
          class="nav-subitem"
        />

        <v-list-item
          v-if="hasRouteOperatorModules && admitsName('RouteOperatorMap')"
          prepend-icon="mdi:map-marker-path"
          title="Mapa de Mi Ruta"
          :to="{ name: 'RouteOperatorMap' }"
          :active="$route.name === 'RouteOperatorMap'"
          class="nav-subitem"
        />
      </v-list-group>

      <!-- 🚨 GESTIÓN DE INCIDENCIAS -->
  <v-list-group v-if="hasIncidentsAccess && admitsAnyName(['Incidents'])" value="incidents">
        <template #activator="{ props }">
          <v-list-item
            v-bind="props"
            prepend-icon="mdi:alert-circle"
            :title="isRail ? '' : 'Incidencias'"
            color="error"
            @click="ensureExpandedForInteraction()"
          />
        </template>

        <v-list-item
          v-if="admitsName('Incidents')"
          prepend-icon="mdi:alert-multiple"
          title="Todas las Incidencias"
          :to="{ name: 'Incidents' }"
          :active="$route.name === 'Incidents'"
          class="nav-subitem"
        >
          <template v-if="!collapsed" #append>
            <v-badge
              v-if="incidentsCount > 0"
              :content="incidentsCount"
              color="error"
            />
          </template>
        </v-list-item>

        <!-- TEMPORALMENTE DESHABILITADO: AdvancedIncidents no existe en router
        <v-list-item
          v-if="hasAdvancedIncidents"
          prepend-icon="mdi-alert-octagon"
          title="Gestión Avanzada"
          :to="{ name: 'AdvancedIncidents' }"
          :active="$route.name === 'AdvancedIncidents'"
          class="nav-subitem"
        />
        -->

      </v-list-group>

      <!-- �️ SISTEMA DE MAPAS -->
  <v-list-group v-if="hasMapsAccess && admitsAnyName(['Maps'])" value="maps">
        <template #activator="{ props }">
          <v-list-item
            v-bind="props"
            prepend-icon="mdi:map"
            :title="isRail ? '' : 'Mapas'"
            color="success"
            @click="ensureExpandedForInteraction()"
          />
        </template>

        <v-list-item
          v-if="admitsName('Maps')"
          prepend-icon="mdi:map-marker-multiple"
          title="Mapa Interactivo"
          :to="{ name: 'Maps' }"
          :active="$route.name === 'Maps'"
          class="nav-subitem"
        />

        <!-- P13-V7B — "Mapas Regionales" retired with its route. It was offered to super_admin while
             the route admitted only group_manager (the click ended on /access-denied), and the page
             behind it published zeros it never measured. -->
      </v-list-group>

      <!-- 👥 GESTIÓN DE USUARIOS -->
  <v-list-group v-if="hasUsersAccess && admitsAnyName(['UserManagement'])" value="users">
        <template #activator="{ props }">
          <v-list-item
            v-bind="props"
            prepend-icon="mdi:account-group"
            :title="isRail ? '' : 'Usuarios'"
            color="blue"
            @click="ensureExpandedForInteraction()"
          />
        </template>

        <v-list-item
          v-if="admitsName('UserManagement')"
          prepend-icon="mdi:account-multiple"
          title="Gestión de Usuarios"
          :to="{ name: 'UserManagement' }"
          :active="$route.name === 'UserManagement'"
          class="nav-subitem"
        />

        <!-- TEMPORALMENTE DESHABILITADO: AdvancedUserManagement no existe en router
        <v-list-item
          v-if="hasAdvancedUserManagement"
          prepend-icon="mdi-account-cog"
          title="Gestión Avanzada"
          :to="{ name: 'AdvancedUserManagement' }"
          :active="$route.name === 'AdvancedUserManagement'"
          class="nav-subitem"
        />
        -->
      </v-list-group>

      <!-- 🏢 GESTIÓN DE GRUPOS -->
  <v-list-group v-if="hasGroupsAccess && admitsAnyName(['SuperAdminGroupsManagement', 'SuperAdminAgenciesManagement', 'EmployeeAssignments'])" value="groups">
        <template #activator="{ props }">
          <v-list-item
            v-bind="props"
            prepend-icon="mdi:account-supervisor"
            :title="isRail ? '' : 'Grupos'"
            color="indigo"
            @click="ensureExpandedForInteraction()"
          />
        </template>

        <v-list-item
          v-if="admitsName('SuperAdminGroupsManagement')"
          prepend-icon="mdi:account-group"
          title="Gestión de Grupos"
          :to="{ name: 'SuperAdminGroupsManagement' }"
          :active="$route.name === 'SuperAdminGroupsManagement'"
          class="nav-subitem"
        >
          <template v-if="!isRail" #append>
            <v-badge
              v-if="groupsCount > 0"
              :content="groupsCount"
              color="indigo"
              size="small"
            />
          </template>
        </v-list-item>

        <v-list-item
          v-if="admitsName('SuperAdminAgenciesManagement')"
          prepend-icon="mdi:store-multiple"
          title="Gestión de Agencias"
          :to="{ name: 'SuperAdminAgenciesManagement' }"
          :active="$route.name === 'SuperAdminAgenciesManagement'"
          class="nav-subitem"
        >
          <template v-if="!isRail" #append>
            <v-badge
              v-if="agenciesCount > 0"
              :content="agenciesCount"
              color="teal"
              size="small"
            />
          </template>
        </v-list-item>

        <v-list-item
          v-if="admitsName('EmployeeAssignments')"
          prepend-icon="mdi:account-arrow-right"
          title="Asignaciones de Empleados"
          :to="{ name: 'EmployeeAssignments' }"
          :active="$route.name === 'EmployeeAssignments'"
          class="nav-subitem"
        >
          <template v-if="!isRail" #append>
            <v-chip
              color="primary"
              size="x-small"
            >
              Nuevo
            </v-chip>
          </template>
        </v-list-item>
      </v-list-group>

      <!-- 🛣️ GESTIÓN DE RUTAS -->
  <v-list-group v-if="hasRoutesAccess && admitsAnyName(['RouteManagement'])" value="routes">
        <template #activator="{ props }">
          <v-list-item
            v-bind="props"
            prepend-icon="mdi:routes"
            :title="isRail ? '' : 'Gestión de Rutas'"
            color="blue"
            @click="ensureExpandedForInteraction()"
          />
        </template>

        <v-list-item
          v-if="admitsName('RouteManagement')"
          prepend-icon="mdi:map-marker-path"
          title="Gestión de Rutas"
          :to="{ name: 'RouteManagement', query: { tab: 'routes' } }"
          :active="$route.name === 'RouteManagement' && $route.query.tab !== 'calendar'"
          class="nav-subitem"
        >
          <template v-if="!isRail" #append>
            <v-chip
              color="success"
              size="x-small"
              variant="flat"
            >
              NEW
            </v-chip>
          </template>
        </v-list-item>

        <v-list-item
          v-if="admitsName('RouteManagement')"
          prepend-icon="mdi:account-hard-hat"
          title="Asignación de Operadores"
          :to="{ name: 'RouteManagement', query: { tab: 'operators' } }"
          :active="$route.name === 'RouteManagement' && $route.query.tab === 'operators'"
          class="nav-subitem"
        >
          <template v-if="!isRail" #append>
            <v-chip
              color="success"
              size="x-small"
              variant="flat"
            >
              NEW
            </v-chip>
          </template>
        </v-list-item>

        <v-list-item
          v-if="admitsName('RouteManagement')"
          prepend-icon="mdi:play-circle-outline"
          title="Ejecuciones de Rutas"
          :to="{ name: 'RouteManagement', query: { tab: 'executions' } }"
          :active="$route.name === 'RouteManagement' && $route.query.tab === 'executions'"
          class="nav-subitem"
        >
          <template v-if="!isRail" #append>
            <v-chip
              color="success"
              size="x-small"
              variant="flat"
            >
              NEW
            </v-chip>
          </template>
        </v-list-item>
      </v-list-group>

      <!-- 📦 INVENTARIO -->
  <v-list-group v-if="hasInventoryAccess && admitsAnyName(['Inventory', 'InventoryRequests', 'OutboundOrders'])" value="inventory">
        <template #activator="{ props }">
          <v-list-item
            v-bind="props"
            prepend-icon="mdi:package-variant"
            :title="isRail ? '' : 'Inventario'"
            color="orange"
            @click="ensureExpandedForInteraction()"
          />
        </template>

        <v-list-item
          v-if="admitsName('Inventory')"
          prepend-icon="mdi:package"
          title="Gestión de Inventario"
          :to="{ name: 'Inventory' }"
          :active="$route.name === 'Inventory'"
          class="nav-subitem"
        />

        <!-- 📋 SOLICITUDES DE INVENTARIO / BANDEJA -->
        <v-list-item
          v-if="admitsName('InventoryRequests')"
          prepend-icon="mdi:clipboard-list"
          title="Solicitudes de Inventario"
          :to="{ name: 'InventoryRequests' }"
          :active="$route.name === 'InventoryRequests'"
          class="nav-subitem"
        />

        <!-- 🚚 ÓRDENES DE SALIDA -->
        <v-list-item
          v-if="admitsName('OutboundOrders')"
          prepend-icon="mdi:truck-delivery"
          title="Órdenes de salida"
          :to="{ name: 'OutboundOrders' }"
          :active="$route.name === 'OutboundOrders'"
          class="nav-subitem"
        />

        <!-- P13-V2A C7: Workspaces de Inventario + Stock Regional RETIRADOS de la navegación
             (PD-V2-01 / backend 410 estable). El item de Stock Regional además garantizaba
             /access-denied a super_admin (guard sólo group_manager). Vistas eliminadas en V2B. -->
      </v-list-group>

      <!-- 🏪 P13-V2B (INV-05 leg FE): jornada de solicitud del agency_employee — visible SOLO al
           rol que la ruta admite (espejo exacto de meta.roles; el servidor deriva el contexto). -->
      <v-list-item
        v-if="hasAgencyEmployeeInventoryRequest && admitsName('AgencyEmployeeInventoryRequest')"
        prepend-icon="mdi:package-variant-plus"
        title="Solicitar Suministros"
        :to="{ name: 'AgencyEmployeeInventoryRequest' }"
        :active="$route.name === 'AgencyEmployeeInventoryRequest'"
      />

      <!-- 📁 Legacy Navigation Items (restored) -->
      <template v-for="legacy in legacyMenuItems" :key="legacy.id">
        <v-list-group
          v-if="legacy.children?.length"
          :value="legacy.value"
        >
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              :prepend-icon="legacy.icon"
              :title="isRail ? '' : legacy.title"
              :value="`${legacy.id}-activator`"
              class="nav-item"
              color="primary"
              @click="ensureExpandedForInteraction()"
            />
          </template>

          <v-list-item
            v-for="child in legacy.children"
            :key="child.id"
            :to="child.to"
            :title="child.title"
            :prepend-icon="child.icon"
            :value="child.value"
            class="nav-subitem"
          />
        </v-list-group>

        <v-list-item
          v-else
          :prepend-icon="legacy.icon"
          :title="legacy.title"
          :to="legacy.to"
          :value="legacy.value"
          class="nav-item"
        />
      </template>

      <!-- � REPORTES Y ANALYTICS -->
  <v-list-group v-if="hasReportsAccess && admitsAnyName(['ReportsCenter', 'ExecutiveReports', 'RealtimeReports', 'Phase6Suite', 'SuperAdminExpenseReports'])" value="reports">
        <template #activator="{ props }">
          <v-list-item
            v-bind="props"
            prepend-icon="mdi:chart-box-multiple"
            :title="isRail ? '' : 'Reportes'"
            color="purple"
            @click="ensureExpandedForInteraction()"
          />
        </template>

        <v-list-item
          v-if="admitsName('ReportsCenter')"
          prepend-icon="mdi:view-dashboard-variant"
          title="Centro de Reportes"
          :to="{ name: 'ReportsCenter' }"
          :active="$route.name === 'ReportsCenter'"
          class="nav-subitem"
        />

        <v-list-item
          v-if="admitsName('ExecutiveReports')"
          prepend-icon="mdi:briefcase-chart"
          title="Reportes Ejecutivos"
          :to="{ name: 'ExecutiveReports' }"
          :active="$route.name === 'ExecutiveReports'"
          class="nav-subitem"
        />

        <v-list-item
          v-if="admitsName('RealtimeReports')"
          prepend-icon="mdi:speedometer"
          title="Reportes Tiempo Real"
          :to="{ name: 'RealtimeReports' }"
          :active="$route.name === 'RealtimeReports'"
          class="nav-subitem"
        />

        <v-list-item
          v-if="admitsName('Phase6Suite')"
          prepend-icon="mdi:flash"
          title="Suite Analítica"
          :to="{ name: 'Phase6Suite' }"
          :active="$route.name === 'Phase6Suite'"
          class="nav-subitem"
        />
        
        <!-- P13-V7B-MIN C2 — "Reportes POS" retired: `POSSupervisorReport` is not a route name that
             exists anywhere in the router, so the entry could never navigate. Its visibility condition
             (`hasPOSSupervisorReports`) is true for route_operator, a DEMO-REQUIRED role, and this
             sidebar is reachable by the demo roles through the `/dashboard/*` subtree — so it was a
             broken link on a commercial actor's surface. POS reporting is V4/V5A-owned and is not
             implemented here. -->

        <!-- P13-V7B — "Reportes Regionales" retired: `GroupManagerReport` is a retirement notice with
             no data behind it (its producer family was retired); an entry that leads to a notice is a
             promise the product does not keep. -->
        
        <!-- 💰 Reportes de Gastos (SuperAdmin) -->
        <v-list-item
          v-if="hasRole('super_admin') && admitsName('SuperAdminExpenseReports')"
          prepend-icon="mdi:cash-multiple"
          title="Reportes de Gastos"
          :to="{ name: 'SuperAdminExpenseReports' }"
          :active="$route.name === 'SuperAdminExpenseReports'"
          class="nav-subitem"
        />
      </v-list-group>

      <!-- 📈 P13-V7B — the "Analytics" group is RETIRED from the navigation.
           Its four entries advertised capability that has no producer: "Dashboard Analytics" and
           "KPIs" were two labels for the same page, whose four cards can only ever print "Sin datos
           disponibles"; "Business Intelligence" and "Analytics Avanzados" open the notices P13-V5A-R5
           left when it retired their literal figures. The routes still resolve and still say so
           honestly to whoever opens them by URL; the menu simply stops promising them. The measured
           indicators live on the role home and in the organizational and executive reports. -->

      <!-- 📅 AGENDA EMPRESARIAL (P12 post-Gate-A) — visibilidad === meta.roles del router -->
      <v-list-group v-if="hasAgendaAccess && admitsAnyName(['agenda-my', 'agenda-assigned', 'agenda-invitations', 'agenda-organized', 'agenda-team', 'agenda-delegated'])" value="agenda">
        <template #activator="{ props }">
          <v-list-item
            v-bind="props"
            prepend-icon="mdi:calendar-clock"
            :title="isRail ? '' : 'Agenda'"
            color="teal"
            @click="ensureExpandedForInteraction()"
          />
        </template>

        <v-list-item
          v-if="admitsName('agenda-my')"
          prepend-icon="mdi:calendar-account"
          title="Mi Agenda"
          :to="{ name: 'agenda-my' }"
          :active="$route.name === 'agenda-my'"
          class="nav-subitem"
        />

        <v-list-item
          v-if="admitsName('agenda-assigned')"
          prepend-icon="mdi:clipboard-account"
          title="Asignadas a mí"
          :to="{ name: 'agenda-assigned' }"
          :active="$route.name === 'agenda-assigned'"
          class="nav-subitem"
        >
          <template v-if="!collapsed" #append>
            <v-badge
              v-if="agendaInboxStore.assignedBadge > 0"
              :content="agendaInboxStore.assignedBadge"
              color="warning"
              size="small"
            />
          </template>
        </v-list-item>

        <v-list-item
          v-if="admitsName('agenda-invitations')"
          prepend-icon="mdi:email-outline"
          title="Invitaciones"
          :to="{ name: 'agenda-invitations' }"
          :active="$route.name === 'agenda-invitations'"
          class="nav-subitem"
        >
          <template v-if="!collapsed" #append>
            <v-badge
              v-if="agendaInboxStore.invitationBadge > 0"
              :content="agendaInboxStore.invitationBadge"
              color="error"
              size="small"
            />
          </template>
        </v-list-item>

        <v-list-item
          v-if="hasAgendaCoordinationAccess && admitsName('agenda-organized')"
          prepend-icon="mdi:account-tie"
          title="Organizadas por mí"
          :to="{ name: 'agenda-organized' }"
          :active="$route.name === 'agenda-organized'"
          class="nav-subitem"
        >
          <template v-if="!collapsed" #append>
            <v-badge
              v-if="agendaInboxStore.organizedBadge > 0"
              :content="agendaInboxStore.organizedBadge"
              color="info"
              size="small"
            />
          </template>
        </v-list-item>

        <v-list-item
          v-if="hasAgendaCoordinationAccess && admitsName('agenda-team')"
          prepend-icon="mdi:account-group"
          title="Equipo"
          :to="{ name: 'agenda-team' }"
          :active="$route.name === 'agenda-team'"
          class="nav-subitem"
        />

        <v-list-item
          v-if="admitsName('agenda-delegated')"
          prepend-icon="mdi:account-switch"
          title="Delegadas"
          :to="{ name: 'agenda-delegated' }"
          :active="$route.name === 'agenda-delegated'"
          class="nav-subitem"
        />
      </v-list-group>

      <!-- TEMPORALMENTE DESHABILITADO: Rutas de perfiles no existen en router
      <v-divider class="my-2" />
      <v-list-group v-if="hasProfilesAccess">
        <template #activator="{ props }">
          <v-list-item
            v-bind="props"
            prepend-icon="mdi-account-group"
            :title="collapsed ? '' : 'Perfiles'"
          />
        </template>

        <v-list-item
          prepend-icon="mdi-format-list-bulleted"
          title="Lista de Perfiles"
          :to="{ name: 'ProfilesList' }"
          :active="$route.name === 'ProfilesList'"
          class="nav-subitem"
        />
        
        <v-list-item
          prepend-icon="mdi-plus"
          title="Crear Perfil"
          :to="{ name: 'ProfileCreate' }"
          :active="$route.name === 'ProfileCreate'"
          class="nav-subitem"
        />
        
        <v-list-item
          prepend-icon="mdi-chart-box"
          title="Analytics"
          :to="{ name: 'ProfilesAnalytics' }"
          :active="$route.name === 'ProfilesAnalytics'"
          class="nav-subitem"
        />
      </v-list-group>
      -->

      <!-- 📈 Real-time Analytics - TEMPORALMENTE DESHABILITADO -->
      <!--
      <v-list-item
        v-if="hasRealtimeAccess"
        prepend-icon="mdi-pulse"
        title="Tiempo Real"
        :to="{ name: 'AnalyticsRealtime' }"
        :active="$route.name === 'AnalyticsRealtime'"
        class="nav-item"
      >
        <template v-if="!collapsed" #append>
          <v-icon
            :color="realtimeStatus === 'connected' ? 'success' : 'error'"
            size="small"
          >
            mdi-circle
          </v-icon>
        </template>
      </v-list-item>
      -->

      <v-divider class="my-2" />

      <!-- ⚙️ P13-V7B-MIN C2 — "Configuración" retired. It pointed at `DevCenter`, a CONTAINED LAB
           route: outside dev/test builds `createContainedLabRoute` turns it into a component-less
           redirect, so the item bounced the actor away instead of opening settings. It carried no
           role condition at all, so every actor rendering this sidebar — including the demo roles —
           saw it. Product configuration is not a V7B-MIN capability and is not implemented here. -->

      <!-- 🔔 Notifications — P13-V7B-MIN C2: retargeted to the real notifications surface.
           This item pointed at `{ name: 'Home' }`, the PUBLIC WELCOME PAGE: an unconditional entry,
           visible to every role, whose promise ("Notificaciones", with an unread badge) was answered
           by a marketing screen. `DashboardNotifications` is the live notifications view backed by the
           durable notification history and the realtime channel, so this is a target correction, not a
           new feature. -->
      <v-list-item
        v-if="admitsName('DashboardNotifications')"
        prepend-icon="mdi-bell"
        title="Notificaciones"
        :to="{ name: 'DashboardNotifications' }"
        :active="$route.name === 'DashboardNotifications'"
        class="nav-item"
      >
        <template v-if="!collapsed" #append>
          <v-badge
            v-if="totalNotifications > 0"
            :content="totalNotifications"
            color="error"
          />
        </template>
      </v-list-item>
    </v-list>

    <!-- 🦶 Footer Actions -->
    <div class="sidebar-footer pa-2">
      <v-divider class="mb-2" />
      
      <!-- 🌓 Theme Toggle -->
      <v-list-item
        v-if="!collapsed"
        prepend-icon="mdi-brightness-6"
        title="Tema"
        @click="toggleTheme"
        class="nav-item"
      >
        <template #append>
          <v-switch
            :model-value="isDarkTheme"
            hide-details
            inset
            color="primary"
            @update:model-value="toggleTheme"
          />
        </template>
      </v-list-item>

      <v-btn
        v-else
        :icon="isDarkTheme ? 'mdi-brightness-4' : 'mdi-brightness-7'"
        variant="text"
        size="small"
        @click="toggleTheme"
        class="mb-2"
        aria-label="Cambiar tema"
      />

      <!-- 👤 User Info (collapsed) -->
      <div v-if="collapsed && user" class="text-center">
        <v-avatar size="32">
          <v-img
            v-if="user.avatar"
            :src="user.avatar"
            :alt="user.fullName"
          />
          <v-icon v-else icon="mdi-account"></v-icon>
        </v-avatar>
      </div>

      <!-- 👤 User Info (expanded) -->
      <v-list-item
        v-else-if="user"
        class="user-info"
      >
        <template #prepend>
          <v-avatar size="32">
            <v-img
              v-if="user.avatar"
              :src="user.avatar"
              :alt="user.fullName"
            />
            <v-icon v-else icon="mdi-account"></v-icon>
          </v-avatar>
        </template>

        <v-list-item-title class="text-body-2">
          {{ user.fullName }}
        </v-list-item-title>
        <v-list-item-subtitle class="text-caption">
          {{ user.role }}
        </v-list-item-subtitle>
      </v-list-item>

      <!-- 🚪 Logout — canonical session exit (auth store contract) -->
      <v-list-item
        v-if="!collapsed"
        prepend-icon="mdi-logout"
        title="Cerrar Sesión"
        color="error"
        class="nav-item logout-item"
        data-testid="sidebar-logout"
        aria-label="Cerrar sesión"
        role="button"
        tabindex="0"
        @click="handleLogout"
        @keydown.enter="handleLogout"
        @keydown.space.prevent="handleLogout"
      />
      <div v-else class="text-center">
        <v-btn
          icon="mdi-logout"
          variant="text"
          size="small"
          color="error"
          class="mt-2"
          data-testid="sidebar-logout"
          aria-label="Cerrar sesión"
          @click="handleLogout"
        />
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script setup lang="ts">
import { computed, ref, onMounted, watch } from 'vue'
import { useRoute, useRouter, type RouteLocationRaw } from 'vue-router'
import { useTheme } from 'vuetify'
import { useAuthStore, type UserRole } from '@/stores/auth'
import { useNavigationStore } from '@/stores/navigation'
import { useUnifiedNavigation } from '@/services/unified-navigation.service'
import { useAgendaInboxStore } from '@/stores/agendaInbox'
import { AGENDA_PILOT_SURFACE_ROLES } from '@/router/guards'
import { useRouteAdmission } from '@/composables/useRouteAdmission'
// Estado efectivo de rail (colapsado visual)
const isRail = computed(() => props.collapsed && !forceExpanded.value)
const agendaInboxStore = useAgendaInboxStore()


// 🎯 Props
interface Props {
  collapsed?: boolean
}

const props = defineProps<Props>()

// 🎯 Emits
const emit = defineEmits<{
  'toggle': []
  'close': []
}>()

// 🏪 Stores & Composables
const authStore = useAuthStore()
const navigationStore = useNavigationStore()
const route = useRoute()
const router = useRouter()
const theme = useTheme()
const { mainMenu: unifiedMainMenu } = useUnifiedNavigation()

// P13-V7B — THE LAST WORD ON WHAT THIS MENU MAY DRAW.
// Every `has*` flag below is a hand-written mirror of somebody's role list, and mirrors drift: this
// drawer offered the vendor "Mapas Regionales", a route that admits only `group_manager`, and the click
// ended on /access-denied. The flags stay (accepted gates pin several of them) but none of them decides
// alone any more: an entry is drawn only if the router itself has a screen at that name AND its route
// admits the role of this session — the same rule `canonicalGuard` applies on navigation. A group is
// drawn only when at least one of its entries is.
const { admits, admitsName } = useRouteAdmission()
const admitsAnyName = (names: string[]): boolean => names.some(admitsName)

// 🎯 Helper functions para verificación de roles con tipos seguros
const hasRole = (role: UserRole): boolean => {
  const currentRole = authStore.userRole as UserRole | null
  return currentRole === role
}

const hasAnyRole = (...roles: UserRole[]): boolean => {
  const currentRole = authStore.userRole as UserRole | null
  return currentRole ? roles.includes(currentRole) : false
}

// 📱 Reactive state
const dashboardNotifications = ref(0)
const totalNotifications = ref(0)
const realtimeStatus = ref<'connected' | 'disconnected'>('connected')
const incidentsCount = ref(0)
// Grupos abiertos del v-list (controlado por v-model:opened)
const openedGroups = ref<Array<string | number>>([])

// 🎯 Computed properties
const user = computed(() => authStore.user)
const userPermissions = computed(() => authStore.userPermissions || [])
const isDarkTheme = computed(() => theme.current.value.dark)

// 🚫 Navigation visibility control
const shouldShowNavigation = computed(() => {
  // Rutas donde NO debe mostrarse la navegación
  const hiddenRoutes = ['RoleSelector', 'Home', 'SimpleAuth', 'WelcomePage']
  
  // No mostrar si estamos en una ruta de selección/autenticación
  if (hiddenRoutes.includes(route.name as string)) {
    return false
  }
  
  // No mostrar si no hay usuario autenticado
  if (!authStore.isAuthenticated) {
    return false
  }
  
  // No mostrar si no hay rol seleccionado
  if (!authStore.userRole) {
    return false
  }
  
  return true
})

// 🔐 Access control
const hasProfilesAccess = computed(() => 
  userPermissions.value.includes('profiles.view') ||
  userPermissions.value.includes('profiles.list') ||
  hasRole('super_admin')
)

const hasRealtimeAccess = computed(() => 
  userPermissions.value.includes('analytics.realtime') ||
  hasRole('super_admin')
)

// P13-V1D (C10, decisión #18): la visibilidad del grupo de incidencias se alinea con los
// meta.roles REALES de la ruta /incidents — la puerta por permiso anunciaba la ruta a roles que el
// guard rechaza con /access-denied.
// P13-V7A: `administration_manager` sale de /incidents (sus productores le responden NONE/403), y
// el espejo sale con él: super_admin y department_head.
const hasIncidentsAccess = computed(() =>
  hasRole('super_admin') || hasRole('department_head')
)

// 👥 Access controls for user management - Solo roles administrativos
const hasUsersAccess = computed(() => 
  userPermissions.value.includes('users.view') ||
  userPermissions.value.includes('users.manage') ||
  hasAnyRole('super_admin', 'group_manager')
)

// 👑 Access control for SuperAdmin Dashboard
const hasSuperAdminDashboard = computed(() => 
  hasRole('super_admin')
)

// 🏢 Access controls for groups management - Solo SuperAdmin
const hasGroupsAccess = computed(() => 
  userPermissions.value.includes('groups.view') ||
  userPermissions.value.includes('groups.manage') ||
  hasRole('super_admin')
)

// 🛣️ Access controls for routes management - SuperAdmin y supervisores
const hasRoutesAccess = computed(() => 
  userPermissions.value.includes('routes.view') ||
  userPermissions.value.includes('routes.manage') ||
  hasAnyRole('super_admin', 'group_manager')
)

const hasReducedOperationalRole = computed(() =>
  hasAnyRole('field_supervisor', 'route_operator', 'agency_employee', 'group_manager')
)

// 🗺️ Access controls for global maps - admin roles only after B5B
// P13-V7A: `administration_manager` sale de /maps* (todas las capas le responden NONE/403); el
// espejo se alinea con los meta.roles reales de la ruta: super_admin.
const hasMapsAccess = computed(() =>
  !hasReducedOperationalRole.value && (
    userPermissions.value.includes('maps.view') ||
    userPermissions.value.includes('gis.access') ||
    hasRole('super_admin')
  )
)

// 📊 New access controls for reports system (Solo SuperAdmin)
const hasReportsAccess = computed(() => 
  userPermissions.value.includes('reports.view') ||
  userPermissions.value.includes('reports.read') ||
  hasAnyRole('super_admin', 'group_manager')
)

const hasFieldSupervisorReports = computed(() => 
  userPermissions.value.includes('reports.field_supervisor')
)

const hasPOSSupervisorReports = computed(() => 
  userPermissions.value.includes('reports.pos_supervisor') ||
  hasRole('route_operator')
)

// 🎯 Access controls for supervisor modules - Solo FieldSupervisor
const hasSupervisorIncidents = computed(() => 
  userPermissions.value.includes('incidents.supervisor') ||
  hasRole('field_supervisor')
)

const hasSupervisorMaps = computed(() => 
  userPermissions.value.includes('maps.supervisor') ||
  hasRole('field_supervisor')
)

// 🚚 Access controls for route operator modules - Solo RouteOperator
const hasRoutePOSManagement = computed(() => 
  userPermissions.value.includes('pos.route_management') ||
  hasRole('route_operator')
)

// 🔧 Module grouping controls - Roles específicos únicamente
const hasSupervisorModules = computed(() => 
  hasRole('field_supervisor')
)

const hasRouteOperatorModules = computed(() => 
  hasRole('route_operator')
)

const hasAdvancedIncidents = computed(() => 
  userPermissions.value.includes('incidents.advanced') ||
  hasRole('group_manager')
)

const hasAdvancedUserManagement = computed(() => 
  userPermissions.value.includes('users.advanced') ||
  hasRole('super_admin')
)

const hasInventoryAccess = computed(() => 
  userPermissions.value.includes('inventory.view') ||
  hasRole('super_admin') ||
  authStore.userRole === 'administration_manager'
)

// P13-V2A C7: hasRegionalInventory / hasInventoryWorkspaces retirados con sus items de navegación
// (PD-V2-01; superficies backend 410).

// P13-V2B (INV-05 leg FE): visibilidad de la jornada de solicitud del agency_employee —
// espejo exacto de los meta.roles de la ruta.
// WS4 · H3: el espejo se LEE del registro de ruta en vez de repetir el rol a mano — la ruta ya no admite a
// agency_employee (el backend contiene la solicitud de inventario para las identidades entregadas), y una
// copia manual habría seguido anunciando una capacidad que el guard canónico y el backend deniegan.
const hasAgencyEmployeeInventoryRequest = computed(() => {
  const record = router.resolve({ name: 'AgencyEmployeeInventoryRequest' })
  const roles = (record?.meta?.roles as readonly string[] | undefined) ?? []
  return roles.includes(authStore.userRole || '')
})

// 📅 Agenda Empresarial (P12 post-Gate-A): visibilidad = MISMOS arrays de roles
// que declara el router (fuente única; ver src/router/guards.ts)
// MGI-PILOT-W2G: la visibilidad deriva de la MISMA autoridad de superficie que declaran las rutas,
// asi que la navegacion no puede anunciar una Agenda que el guard canonico (y el backend) deniegan.
// Tambien apaga el sondeo del inbox: loadSummary() cuelga de hasAgendaAccess, de modo que una
// identidad contenida deja de pedir resumenes que ahora recibirian 403.
const hasAgendaAccess = computed(() =>
  (AGENDA_PILOT_SURFACE_ROLES as readonly string[]).includes(authStore.userRole || '')
)
const hasAgendaCoordinationAccess = computed(() =>
  (AGENDA_PILOT_SURFACE_ROLES as readonly string[]).includes(authStore.userRole || '')
)

// 📊 Additional reactive data
const supervisorIncidentsCount = ref(0)
const groupsCount = ref(0)
const agenciesCount = ref(0)

interface LegacyMenuItem {
  id: string
  title: string
  icon: string
  to?: RouteLocationRaw
  children?: LegacyMenuItem[]
  value: string
}

const legacyRouteMap: Record<string, RouteLocationRaw> = {
  '/dashboard/super-admin': { name: 'SuperAdminDashboard' },
  '/admin/dashboard': { name: 'SuperAdminDashboard' },
  '/super-admin': { name: 'SuperAdminDashboard' },
  '/super-admin/dashboard-consolidated': { name: 'SuperAdminDashboardConsolidated' },
  '/super-admin/business-intelligence': { name: 'SuperAdminBusinessIntelligence' },
  '/advanced-services': { name: 'AdvancedServices' },
  '/users': { name: 'UserManagement' },
  '/users/list': { name: 'UserManagement' },
  '/users/create': { name: 'UserManagement' },
  '/users/roles': { name: 'UserManagement' },
  '/groups': { name: 'SuperAdminGroupsManagement' },
  '/groups/list': { name: 'SuperAdminGroupsManagement' },
  '/groups/create': { name: 'SuperAdminGroupsManagement' },
  '/groups/agencies': { name: 'SuperAdminAgenciesManagement' },
  '/super-admin/groups-management': { name: 'SuperAdminGroupsManagement' },
  '/super-admin/agencies-management': { name: 'SuperAdminAgenciesManagement' },
  '/management/departments': { name: 'DepartmentManagement' },
  '/management/users-departments': { name: 'UserDepartmentManagement' },
  '/departments': { name: 'Departments' },
  '/assignments': { name: 'Assignments' },
  '/assignments/management': { name: 'AssignmentsManagement' },
  '/analytics': { name: 'Analytics' },
  '/analytics/overview': { name: 'Analytics' },
  '/analytics/advanced': { name: 'AdvancedAnalytics' },
  '/business-intelligence': { name: 'BusinessIntelligence' },
  '/reports': { name: 'ReportsCenter' },
  '/reports/executive': { name: 'ExecutiveReports' },
  '/reports/realtime': { name: 'RealtimeReports' },
  '/reports/analytics-suite': { name: 'Phase6Suite' },
  '/reports/group-manager': { name: 'GroupManagerReport' },
  '/reports/organizational': { name: 'OrganizationalReportsIndependent' },
  '/inventory': { name: 'Inventory' },
  '/inventory/requests': { name: 'InventoryRequests' },
  '/inventory/outbound': { name: 'OutboundOrders' },
  // P13-V2A C7: mapeos de workspaces retirados (PD-V2-01; rutas eliminadas del router).
  '/maps': { name: 'Maps' },
  '/maps/interactive': { name: 'InteractiveMap' },
  '/maps/monitoring': { name: 'MapMonitoring' },
  '/system': { path: '/dev-center' },
  '/system/config': { path: '/dev-center' },
  '/system/logs': { path: '/dev-center' },
  '/system/backups': { path: '/dev-center' },
  '/dev-center': { name: 'DevCenter' },
  '/dev-center/api-testing': { name: 'ApiTesting' },
  '/dev-center/performance-metrics': { name: 'PerformanceMetrics' }
}

const hiddenLegacyRouteNames = new Set<string>([
  'SuperAdminDashboard',
  'UserManagement',
  'SuperAdminGroupsManagement',
  'SuperAdminAgenciesManagement',
  'Inventory',
  'InventoryRequests',
  'OutboundOrders',
  // P13-V2B: los nombres de rutas RETIRADAS (InventoryWorkspaces · InventoryWorkspacesAnalytics ·
  // RegionalStockManagement) fueron purgados — las rutas no existen desde V2A (PD-V2-01).
  'Maps',
  'InteractiveMap',
  'MapMonitoring',
  'BusinessIntelligence',
  'Analytics',
  'AdvancedAnalytics',
  'ReportsCenter',
  'ExecutiveReports',
  'RealtimeReports',
  'Phase6Suite',
  'GroupManagerReport',
  'DevCenter',
  'ApiTesting',
  'PerformanceMetrics'
])

const hiddenLegacyRoutePaths = new Set<string>([
  '/super-admin',
  '/admin/dashboard',
  '/users',
  '/super-admin/groups-management',
  '/super-admin/agencies-management',
  '/inventory',
  '/inventory/requests',
  '/inventory/outbound',
  // P13-V2B: las rutas RETIRADAS (/inventory/workspaces · /inventory/workspaces/analytics ·
  // /group-manager/stock) fueron purgadas de este set — no existen desde V2A.
  '/maps',
  '/maps/interactive',
  '/maps/monitoring',
  '/business-intelligence',
  '/analytics',
  '/analytics/advanced',
  '/reports',
  '/reports/executive',
  '/reports/realtime',
  '/reports/analytics-suite',
  '/reports/group-manager',
  '/dev-center',
  '/dev-center/api-testing',
  '/dev-center/performance-metrics'
])

const shouldHideLegacyEntry = (location: RouteLocationRaw | null): boolean => {
  if (!location) {
    return false
  }

  if (typeof location === 'string') {
    if (hiddenLegacyRoutePaths.has(location)) {
      return true
    }

    const mapped = legacyRouteMap[location]
    return shouldHideLegacyEntry(mapped as RouteLocationRaw | null)
  }

  const candidate = location as Record<string, any>

  if (typeof candidate.name === 'string' && hiddenLegacyRouteNames.has(candidate.name)) {
    return true
  }

  if (typeof candidate.path === 'string' && hiddenLegacyRoutePaths.has(candidate.path)) {
    return true
  }

  const normalizedPath = getRoutePath(location)
  return !!normalizedPath && hiddenLegacyRoutePaths.has(normalizedPath)
}

const allRouterRoutes = router.getRoutes()
const availableRoutePaths = new Set<string>(allRouterRoutes.map(routeRecord => routeRecord.path))
const availableRouteNames = new Set<string>()
const routeByName = new Map<string, (typeof allRouterRoutes)[number]>()

allRouterRoutes.forEach(routeRecord => {
  if (typeof routeRecord.name === 'string') {
    availableRouteNames.add(routeRecord.name)
    routeByName.set(routeRecord.name, routeRecord)
  }
})

const getRoutePath = (location: RouteLocationRaw): string | null => {
  if (!location) {
    return null
  }

  if (typeof location === 'string') {
    return availableRoutePaths.has(location) ? location : null
  }

  const candidate = location as Record<string, any>

  if (typeof candidate.name === 'string' && routeByName.has(candidate.name)) {
    return routeByName.get(candidate.name)!.path
  }

  if (typeof candidate.path === 'string') {
    if (availableRoutePaths.has(candidate.path)) {
      return candidate.path
    }

    const mapped = legacyRouteMap[candidate.path]
    if (mapped) {
      return getRoutePath(mapped)
    }
  }

  return null
}

const resolveLegacyRoute = (rawRoute: any): RouteLocationRaw | null => {
  if (!rawRoute) {
    return null
  }

  if (typeof rawRoute === 'string') {
    if (availableRoutePaths.has(rawRoute)) {
      return { path: rawRoute }
    }

    if (legacyRouteMap[rawRoute]) {
      return { ...(legacyRouteMap[rawRoute] as Record<string, any>) }
    }

    return null
  }

  if (typeof rawRoute === 'object') {
    const candidate = rawRoute as Record<string, any>

    if (typeof candidate.name === 'string' && availableRouteNames.has(candidate.name)) {
      return {
        name: candidate.name,
        params: candidate.params,
        query: candidate.query
      }
    }

    if (typeof candidate.path === 'string') {
      if (availableRoutePaths.has(candidate.path)) {
        return {
          path: candidate.path,
          query: candidate.query
        }
      }

      if (legacyRouteMap[candidate.path]) {
        return { ...(legacyRouteMap[candidate.path] as Record<string, any>) }
      }
    }
  }

  return null
}

const buildLegacyMenuItems = (sourceItems: Array<Record<string, any>>): LegacyMenuItem[] => {
  const mapItem = (item: Record<string, any>, id: string): LegacyMenuItem | null => {
    const resolvedLocation = resolveLegacyRoute(item.route)
    const includeAnchor = resolvedLocation ? !shouldHideLegacyEntry(resolvedLocation) : false
    const childItems = (item.children ?? [])
      .map((child: Record<string, any>, index: number) => mapItem(child, `${id}-child-${index}`))
      .filter((child: LegacyMenuItem | null): child is LegacyMenuItem => !!child)

    if (childItems.length > 0) {
      let effectiveChildren: LegacyMenuItem[] = childItems

      if (includeAnchor && resolvedLocation && admits(resolvedLocation)) {
        effectiveChildren = [
          {
            id: `${id}-anchor`,
            title: item.title,
            icon: item.icon || 'mdi-menu',
            to: resolvedLocation,
            value: `${id}-anchor`
          },
          ...childItems
        ]
      }

      if (effectiveChildren.length === 0) {
        return null
      }

      return {
        id,
        title: item.title,
        icon: item.icon || 'mdi-menu',
        children: effectiveChildren,
        value: `${id}-group`
      }
    }

    if (!resolvedLocation || !includeAnchor) {
      return null
    }

    // P13-V7B: a restored legacy entry obeys the same admission rule as every other entry.
    if (!admits(resolvedLocation)) {
      return null
    }

    return {
      id,
      title: item.title,
      icon: item.icon || 'mdi-menu',
      to: resolvedLocation,
      value: `${id}-link`
    }
  }

  return sourceItems
    .map((item, index) => mapItem(item, `legacy-${index}`))
  .filter((item: LegacyMenuItem | null): item is LegacyMenuItem => !!item)
}

const legacyMenuItems = computed<LegacyMenuItem[]>(() => {
  if (!hasRole('super_admin')) {
    return []
  }

  return buildLegacyMenuItems(unifiedMainMenu.value || [])
})

// �🔄 Methods
const toggleTheme = () => {
  const newTheme = theme.current.value.dark ? 'light' : 'dark'
  theme.global.name.value = newTheme
  // Theme is automatically persisted by Vuetify
}

// 🚪 Logout — delega en el contrato canónico del auth store.
// authStore.logout() invalida la sesión de backend (POST /api/auth/logout),
// limpia la sesión canónica del frontend y desconecta el WebSocket.
// El componente NO duplica esa lógica (sin limpieza manual de localStorage).
const handleLogout = async () => {
  await authStore.logout()
  router.push('/login')
}

// 📊 Real-time connection status
const checkRealtimeStatus = () => {
  const isConnected = navigator.onLine
  realtimeStatus.value = isConnected ? 'connected' : 'disconnected'
}

// � Expansión persistente cuando se abre un grupo en modo rail
const forceExpanded = ref(false)

const ensureExpandedForInteraction = () => {
  if (props.collapsed) {
    forceExpanded.value = true
  }
}

const releaseExpanded = () => {
  forceExpanded.value = false
}

const onToggleClick = () => {
  // Caso especial: si el drawer está "colapsado" pero expandido por interacción
  // (forceExpanded=true), el primer clic debe simplemente liberar esa expansión
  // sin alternar el estado global. Así se vuelve a rail en un solo clic.
  if (props.collapsed && forceExpanded.value) {
    forceExpanded.value = false
    // Al liberar la expansión forzada, cerramos los grupos abiertos
    openedGroups.value = []
    return
  }

  // Comportamiento normal: alternar el colapsado global
  // Si actualmente NO está colapsado, este clic lo cerrará: cerramos grupos
  if (!props.collapsed) {
    openedGroups.value = []
    forceExpanded.value = false
  }
  emit('toggle')
}

// 🎯 Lifecycle
onMounted(() => {
  // Badges de inboxes de Agenda (invitaciones / asignadas / organizadas)
  if (hasAgendaAccess.value) {
    void agendaInboxStore.loadSummary()
  }

  // Check real-time status periodically
  const statusInterval = setInterval(checkRealtimeStatus, 30000)
  checkRealtimeStatus()
  
  // Cleanup
  const cleanup = () => {
    clearInterval(statusInterval)
  }
  
  // Return cleanup function
  return cleanup
})

// Cuando el prop collapsed cambie externamente a true, cerramos grupos y liberamos expansión
watch(
  () => props.collapsed,
  (isCollapsed) => {
    if (isCollapsed) {
      openedGroups.value = []
      forceExpanded.value = false
    }
  }
)

// 📊 Analytics tracking
const trackNavigation = (itemName: string) => {
  if (typeof (window as any).gtag !== 'undefined') {
    (window as any).gtag('event', 'sidebar_navigation', {
      event_category: 'Navigation',
      event_label: itemName,
      sidebar_collapsed: props.collapsed
    })
  }
}
</script>

<style scoped>
.sidebar-navigation {
  height: 100%;
  background: linear-gradient(180deg, rgb(var(--v-theme-surface)) 0%, rgb(var(--v-theme-surface-variant)) 100%);
}

/* Ajustes mínimos para rail (drawer colapsado) */

.sidebar-header {
  border-bottom: 1px solid rgb(var(--v-theme-outline-variant));
  background: rgb(var(--v-theme-surface-bright));
}

.sidebar-footer {
  border-top: 1px solid rgb(var(--v-theme-outline-variant));
  background: rgb(var(--v-theme-surface-dim));
}

.nav-item {
  margin: 2px 8px;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.nav-item:hover {
  background-color: rgb(var(--v-theme-primary) / 0.08);
  transform: translateX(2px);
}

.nav-item.v-list-item--active {
  background-color: rgb(var(--v-theme-primary) / 0.12);
  color: rgb(var(--v-theme-primary));
  transform: none; /* no desplazamiento extra cuando está activo */
}

/* 👑 SuperAdmin specific styling */
.superadmin-item {
  background: linear-gradient(135deg, 
    rgba(var(--v-theme-primary), 0.05) 0%, 
    rgba(var(--v-theme-secondary), 0.05) 100%
  );
  border: 1px solid rgba(var(--v-theme-primary), 0.2);
}

.superadmin-item:hover {
  background: linear-gradient(135deg, 
    rgba(var(--v-theme-primary), 0.1) 0%, 
    rgba(var(--v-theme-secondary), 0.1) 100%
  );
  border-color: rgba(var(--v-theme-primary), 0.4);
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary), 0.3);
}

.superadmin-item.v-list-item--active {
  background: linear-gradient(135deg, 
    rgba(var(--v-theme-primary), 0.15) 0%, 
    rgba(var(--v-theme-secondary), 0.15) 100%
  );
  border-left: 4px solid rgb(var(--v-theme-primary));
  color: rgb(var(--v-theme-primary));
}

.nav-subitem {
  margin: 2px 12px;
  border-radius: 6px;
  font-size: 0.875rem;
}

.nav-subitem:hover {
  background-color: rgb(var(--v-theme-primary) / 0.06);
}

/* Mostrar títulos completos en modo expandido */
.sidebar-navigation .v-list-item-title,
.sidebar-navigation .v-list-item-subtitle {
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
}

.user-info {
  background: rgb(var(--v-theme-surface-variant));
  border-radius: 8px;
  margin: 8px;
}

/* ✨ Animations */
.nav-item {
  position: relative;
  overflow: hidden;
}

.sidebar-navigation .v-list-item__content {
  display: block;
}

.sidebar-navigation .v-list-item-title {
  line-height: 1.1rem;
}

.nav-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 3px;
  height: 100%;
  background-color: rgb(var(--v-theme-primary));
  transform: scaleY(0);
  transition: transform 0.2s ease;
}

.nav-item.v-list-item--active::before {
  transform: scaleY(1);
}

/* En rail, que el indicador no agregue desplazamiento visual */
.v-navigation-drawer--rail .nav-item::before {
  width: 2px;
}

/* Rail overrides to prevent overflow/truncation when active */
.v-navigation-drawer--rail .nav-item:hover {
  transform: none; /* evitar desplazamiento lateral en 64px */
}

.v-navigation-drawer--rail .superadmin-item,
.v-navigation-drawer--rail .superadmin-item.v-list-item--active {
  border-left: 0 !important; /* evitar ensanchar el rail */
}

.v-navigation-drawer--rail .nav-item {
  margin-left: 4px;
  margin-right: 4px;
  overflow: visible; /* evita recortes del indicador activo */
}

/* 🎨 Glassmorphism effect */
.sidebar-header,
.sidebar-footer {
  backdrop-filter: blur(10px);
  background: rgba(var(--v-rgb-surface), 0.8);
}

/* 🍔 Menu toggle button styles */
.menu-toggle-btn {
  transition: all 0.2s ease;
}

.menu-toggle-btn:hover {
  background-color: rgb(var(--v-theme-primary) / 0.1);
  transform: scale(1.05);
}

/* 📱 Mobile responsive */
@media (max-width: 768px) {
  .sidebar-navigation {
    width: 100% !important;
  }
}

/* 📜 Navigation list scrolling */
.navigation-list {
  scrollbar-width: thin;
  scrollbar-color: rgba(var(--v-theme-primary), 0.3) transparent;
}

.navigation-list::-webkit-scrollbar {
  width: 4px;
}

.navigation-list::-webkit-scrollbar-track {
  background: transparent;
}

.navigation-list::-webkit-scrollbar-thumb {
  background-color: rgba(var(--v-theme-primary), 0.3);
  border-radius: 2px;
}

.navigation-list::-webkit-scrollbar-thumb:hover {
  background-color: rgba(var(--v-theme-primary), 0.5);
}

/* 🌗 Dark theme adjustments */
@media (prefers-color-scheme: dark) {
  .sidebar-navigation {
    background: linear-gradient(180deg, rgb(var(--v-theme-surface)) 0%, rgba(var(--v-rgb-surface), 0.8) 100%);
  }
  
  .nav-item:hover {
    background-color: rgb(var(--v-theme-primary) / 0.12);
  }
  
  .nav-item.v-list-item--active {
    background-color: rgb(var(--v-theme-primary) / 0.16);
  }
}

/* 🔄 Loading states */
.nav-item-loading {
  opacity: 0.6;
  pointer-events: none;
}

/* 🎯 Focus styles for accessibility */
.nav-item:focus-visible {
  outline: 2px solid rgb(var(--v-theme-primary));
  outline-offset: 2px;
}

/* ⚡ Performance optimization */
.nav-item {
  will-change: transform, background-color;
}

/* 📊 Status indicators */
.status-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}
</style>
